module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cf943c415522511875f16e7e7b760614.png";